import { keyframes } from '@emotion/react';
import { css, Styles, Theme, withStyles } from '@recruit-robin/robin-theme/web-styles';

const errorKeyframes = (theme: Theme) => keyframes`
  0%   { box-shadow: 0 0 0 0 rgba(0,0,0,0); }
  30%  { box-shadow: 0 0 0 4px ${theme.colors.tertiary.red[50]}; }
  100% { box-shadow: 0 0 0 0 rgba(0,0,0,0); }
`;

const styles = {
  root: ({ props }) => css`
    ${props.contained &&
    css`
      gap: 16px;
      width: 100%;
      max-width: 100%;
    `}
  `,
  dropdown: ({ props }) => css`
    min-width: 250px;
    width: 100%;

    ${props.contained &&
    css`
      gap: 16px;
      width: 100%;
      max-width: 100%;
    `}
  `,
  dropdownProcessingVacancy: css`
    pointer-events: none;
  `,
  menu: css`
    width: 435px;
    display: flex;
    flex-direction: column;
    z-index: 3;
    max-height: 100%;

    && {
      overflow: hidden;
    }
  `,
  inputClosed: ({ theme }) => css`
    color: ${theme.colors.primary.fuchsia[60]};
  `,
  inputError: ({ theme }) => css`
    &,
    &:hover {
      border-color: ${theme.colors.tertiary.red[50]};
      background: white;
    }

    animation: ${errorKeyframes(theme)} 0.44s ease-in-out forwards;
  `,
  tabs: css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 7px 9px 7px 7px;
    height: auto;
    gap: 6px;
    flex: unset;

    border-radius: 12px 12px 0 0;
  `,
  tabsRoot: css`
    overflow: hidden;
  `,
  tabsList: css`
    padding-right: 12px;
    margin-bottom: 12px;

    & > button:first-of-type {
      margin-left: 17px;
    }
  `,
  tabsContent: css`
    padding: 0px;
  `,
  createJobPill: css`
    display: flex;
    margin-left: auto;
    align-self: center;
    flex-direction: row;
    width: fit-content;
    gap: 8px;

    & > div {
      cursor: pointer;
    }
  `,
  disconnectJobPill: css`
    padding: 2px 4px;
  `,
} satisfies Styles<{ contained: boolean }>;

export const useStyles = withStyles(styles);
